import React from 'react'
// import warroom from "../../assets/images/warRoom.png"
import warroom from "../../assets/images/04_EBC Glitch_FINAL.gif"
import useFlickerEffect from '../../hooks/useFlickerEffect.ts';
import Hackedelipse from "../../assets/images/lefteffect2.png";


const TheMission = () => {

    const activeClass = useFlickerEffect();

    return (
        <>
            <section id='EBC' className={`
            relative
            after:block
                after:absolute after:right-0 ${activeClass && 'after:animate-flicker'} 
                after:top-[-250px] sm:after:top-[-200px] md:after:top-[-150px]
                after:w-[280px] sm:after:w-[350px] md:after:w-[400px] lg:after:w-[450px] xl:after:w-[500px] 
                after:h-[900px] sm:after:h-[1000px] md:after:h-[1200px] xl:after:h-[1400px]  
                after:bg-[url('../src/assets/images/righteffeect2.png')] 
                after:bg-no-repeat after:bg-contain after:z-[-1]        
             z-30 px-5`}>
                <div className='max-w-[1440px] w-full mx-auto' >
                <img src={Hackedelipse} className={` xl:block absolute left-0 top-[-80px] hidden md:block ${activeClass && "animate-flicker"}`} alt="elipse" />

                    <div className="   md:pb-[120px] pb-[60px]  " >
                        <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className='text-[28px] md:text-[32px] lg:text-[40px] md:pb-[60px] pb-[30px] text-white text-center font-gothicproMedium leading-[100%]  drop-shadow-custom '>
                        // CYBER RESILIENCE MEETS <br /> EXECUTIVE STRATEGY
                        </h2>
                        <div className='flex relative z-30 min-[1126px]:flex-row items-center gap-5 justify-between flex-col max-w-[1160px] mx-auto  w-full md:px-[15px]' >
                            <img className='min-[1126px]:max-w-[694px] xl:max-h-[414px] w-full mb-[10px] md:mb-[20px]' src={warroom} alt="warroomimage" />
                            <div>
                                <div className='flex flex-col gap-5 md:gap-[30px] lg:gap-[30px]   sm:gap-[22px] min-[1126px]:max-w-[380px] w-full items-start' >
                                    <p className="text-[#C9C9C9] text-[16px] font-inter leading-[140%] font-normal">
                                        The Armory War Room is an advanced cybersecurity hub where ethical hackers leverage the Armory platform to conduct
                                        <span className='text-[16px]  font-bold font-inter text-white ' > real-world attack simulations </span> and <span className='text-[16px] font-bold font-inter text-white text-base' >vulnerability assessments.</span>
                                    </p>
                                    <p className="text-[#C9C9C9] text-[16px] font-inter leading-[140%] font-normal">
                                        Executives can experience <span className='text-[16px]  font-bold font-inter text-white leading-[140%] md:text-[16px]'> live attack scenarios </span>, gain hands-on training in  <span className='text-[16px]  font-bold font-inter text-white leading-[140%]'>cyber risk management</span>, and understand their own <span className='text-[16px] font-bold font-inter text-white leading-[140%]'> digital risk exposure </span>. This immersive environment provides leaders with actionable insights to strengthen their defenses and make informed security decisions in real time.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TheMission